import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
  :host {
    display: block;
    white-space: nowrap;
    @apply --type-base;
  }

  #wrapper {
    @apply --layout;
    @apply --layout-start;
    width: var(--com-radio-wrapper-width, auto);
  }

  .radio-label {
    width: 100%;
  }

  /* Disabled state */
  :host([disabled]) .radio-label {
    cursor: default;
    color: var(--inactive-grey);
  }

  /* Error state */
  :host([error]) .radio-label {
    color: var(--alert-orange);
  }

  .radio-label {
    white-space: normal;
    @apply --com-radio-label;
  }

  [toggle-button] {
    cursor: pointer;
  }

  :host([keyboard-navigation]) {
    @apply --focus;
  }
</style>
</template>`;

styleElement.register('com-radio-style');